/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import { useAction } from '../../../Common/hooks';
import { oneSecond } from '../../../Common/constants';
import { getRejectedFilterOptions, getAgencies } from '../../services';
import { setRejectedFilters } from '../../actions';
import { getRejectedFilters } from '../../selectors';
import { rejectedFiltersInitialState } from '../../reducers';

const useVisitFilterBar = () => {
  const storeFilters = useSelector(getRejectedFilters);
  const setStoreFilters = useAction(setRejectedFilters);
  const debouncedFilterChange = useCallback(debounce(setStoreFilters, oneSecond), []);
  const [partnersOptions, setPartnersOptions] = useState([]);
  const [agencyOptions, setAgencyOptions] = useState([]);
  const [showResetButton, setShowResetButton] = useState(false);
  const [isInputFilter, setIsInputFilter] = useState(false);
  const [filters, setFilters] = useState({ ...storeFilters });

  useEffect(() => {
    if (isInputFilter) {
      debouncedFilterChange(filters);
      setIsInputFilter(false);
    } else {
      setStoreFilters(filters);
    }
    setShowResetButton(!isEqual(filters, rejectedFiltersInitialState));
  }, [filters]);

  useEffect(() => {
    const callFilterOptions = async () => {
      const [partnersFilterOptions, agenciesOptions] = await getRejectedFilterOptions();

      setPartnersOptions(partnersFilterOptions);
      setAgencyOptions(agenciesOptions);
    };

    callFilterOptions();
  }, []);

  const updateAgencyFilterOptions = async value => {
    const requestParams = {
      active: true,
      partnerID: value,
    };

    const agencyOptionsPerPartner = await getAgencies({ filters: requestParams });
    setAgencyOptions(agencyOptionsPerPartner);
  };

  const handleFilterChanges =
    filterName =>
    ({ target: { type, value } }) => {
      const filter = { [filterName]: value };

      if (type === 'text') {
        setIsInputFilter(true);
      }

      if (filterName === 'partnerID') {
        updateAgencyFilterOptions(value);
      }

      setFilters({
        ...filters,
        ...filter,
      });
    };

  const handleResetFilter = () => {
    setFilters({ ...rejectedFiltersInitialState });
    setShowResetButton(false);
  };

  const handleEnterPress = event => {
    if (event.key === 'Enter') {
      debouncedFilterChange.flush();
    }
  };

  return {
    partnersOptions,
    agencyOptions,
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    handleEnterPress,
    filters,
  };
};

export default useVisitFilterBar;
